// React
import React, { useState, useMemo } from "react";

// Internal Components
import AutoResizeTextArea from "../../../../../components/ui/AutoResizeTextarea/AutosizeTextarea";
import SliderTooltip from "../../../../../components/ui/Tooltips/Tooltips";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import ScoreSlider from "./components/ScoreSlider";
import ScoreDisplay from "./components/ScoreDisplay";

function PlanningTile({
  today,
  tooltipPosition,
  continuation,
  startSlider,
  background,
  handleChange,
  deleteTodayKey,
}) {
  return (
    <div className={"tile left"}>
      <div className="dateRow--header">
        <label className="score label">
          {isNaN(continuation)
            ? `My Plan for Day`
            : `My Plan for Day #${continuation}`}
        </label>
      </div>

      <div className="moment__submission">
        <div
          className={
            today.momentOneScore === "10" || today.momentOneScore === undefined
              ? `score__row--moment complete`
              : "score__row--moment"
          }
        >
          <AutoResizeTextArea
            className={"formInput moment"}
            wrap="soft"
            value={today.momentOne ? today.momentOne : ""}
            name="momentOne"
            autoComplete="off"
            placeholder={
              "Slow mindful first hour of the day; tea, stretch, no phone"
            }
            onChange={handleChange}
          />

          <ScoreDisplay
            momentNum="One"
            score={today.momentOneScore}
            text={today.momentOne}
            deleteTodayKey={deleteTodayKey}
          />
        </div>

        <ScoreSlider
          name="momentOneScore"
          score={today.momentOneScore}
          savedBackground={background.momentOneScore}
          handleChange={handleChange}
          sliderGenerator={startSlider}
        />
      </div>

      <div className="moment__submission">
        <div
          className={
            today.momentTwoScore === "10" || today.momentTwoScore === undefined
              ? `score__row--moment complete`
              : "score__row--moment"
          }
        >
          <AutoResizeTextArea
            className={"formInput moment"}
            wrap="soft"
            value={today.momentTwo ? today.momentTwo : ""}
            name="momentTwo"
            autoComplete="off"
            placeholder={"Focus in on important task"}
            onChange={handleChange}
          />
          <ScoreDisplay
            momentNum="Two"
            score={today.momentTwoScore}
            text={today.momentTwo}
            deleteTodayKey={deleteTodayKey}
          />
        </div>
        <ScoreSlider
          name="momentTwoScore"
          score={today.momentTwoScore}
          savedBackground={background.momentTwoScore}
          handleChange={handleChange}
          sliderGenerator={startSlider}
        />
      </div>

      <div className="moment__submission">
        <div
          className={
            today.momentThreeScore === "10" ||
            today.momentThreeScore === undefined
              ? `score__row--moment complete`
              : "score__row--moment"
          }
        >
          <AutoResizeTextArea
            className={"formInput moment"}
            wrap="soft"
            value={today.momentThree ? today.momentThree : ""}
            name="momentThree"
            autoComplete="off"
            placeholder={
              "Read new book for 45 minutes. Meditate for 15 minutes"
            }
            onChange={handleChange}
          />
          <ScoreDisplay
            momentNum="Three"
            score={today.momentThreeScore}
            text={today.momentThree}
            deleteTodayKey={deleteTodayKey}
          />
        </div>

        <ScoreSlider
          name="momentThreeScore"
          score={today.momentThreeScore}
          savedBackground={background.momentThreeScore}
          handleChange={handleChange}
          sliderGenerator={startSlider}
        />
      </div>

      <div className="moment__submission">
        <div
          className={
            today.momentFourScore === "10" ||
            today.momentFourScore === undefined
              ? `score__row--moment complete`
              : "score__row--moment"
          }
        >
          <AutoResizeTextArea
            className={"formInput moment"}
            wrap="soft"
            value={today.momentFour ? today.momentFour : ""}
            name="momentFour"
            autoComplete="off"
            placeholder={"Workout: Biceps"}
            onChange={handleChange}
          />
          <ScoreDisplay
            momentNum="Four"
            score={today.momentFourScore}
            text={today.momentFour}
            deleteTodayKey={deleteTodayKey}
          />
        </div>
        <ScoreSlider
          name="momentFourScore"
          score={today.momentFourScore}
          savedBackground={background.momentFourScore}
          handleChange={handleChange}
          sliderGenerator={startSlider}
        />
      </div>

      <div className="moment__submission">
        <div
          className={
            today.momentFiveScore === "10" ||
            today.momentFiveScore === undefined
              ? `score__row--moment complete`
              : "score__row--moment"
          }
        >
          <AutoResizeTextArea
            className={"formInput moment"}
            wrap="soft"
            value={today.momentFive ? today.momentFive : ""}
            name="momentFive"
            autoComplete="off"
            placeholder={"Wind down before bed; phone away"}
            onChange={handleChange}
          />
          <ScoreDisplay
            momentNum="Five"
            score={today.momentFiveScore}
            text={today.momentFive}
            deleteTodayKey={deleteTodayKey}
          />
        </div>
        <ScoreSlider
          name="momentFiveScore"
          score={today.momentFiveScore}
          savedBackground={background.momentFiveScore}
          handleChange={handleChange}
          sliderGenerator={startSlider}
        />
      </div>
    </div>
  );
}

export default PlanningTile;
